import React, { forwardRef, useState } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { mapChildrenIndexedByType } from "../../helper/map-children";
import { useUniqueId } from "../hooks/useUniqueId";

import { RadioButtonProvider } from "./RadioButtonContext";

import styles from "./RadioButton.scss";

const RadioButtonGroup = forwardRef((props, ref) => {
  const { children, variants, onChange, customClass, ...restProps } = props;
  const { id, name } = restProps;
  const [checkedId, setCheckedId] = useState("");
  const groupId = id || useUniqueId("RadioButton.Group", props) + 1;
  const groupName = name || `radio-${groupId}`;

  function onRadioClick(event) {
    setCheckedId(event.target.id);
    onChange(event.target.value, event);
  }

  return (
    <fieldset
      ref={ref}
      className={cx(styles.fieldset, variants, customClass)}
      {...restProps}
    >
      {mapChildrenIndexedByType(children, (child, childIndexByType) => (
        <RadioButtonProvider
          value={{
            id: groupId,
            name: groupName,
            buttonId: childIndexByType + 1,
            checkedId,
            onRadioClick,
          }}
        >
          {child}
        </RadioButtonProvider>
      ))}
    </fieldset>
  );
});

RadioButtonGroup.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  variants: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  customClass: PropTypes.string,
  onChange: PropTypes.func,
};

RadioButtonGroup.defaultProps = {
  variants: "",
  customClass: "",
  onChange: () => {},
};

RadioButtonGroup.Variant = {
  block: styles.groupBlock,
  inline: styles.groupInline,
};

RadioButtonGroup.displayName = "RadioButton.Group";

export default RadioButtonGroup;
